// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__3iG4Q","title":"AfterFrontImage_title__37mP-"};